import styled, { createGlobalStyle } from 'styled-components';
import { Alert, Divider, Form, Tabs } from 'antd';
import BreadCrumb from '../../../components/BreadCrumb';
import DetailsFilters from './DetailsFilters';

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: #e5e5e5;
`;

export const GlobalPopupButtonStyles = createGlobalStyle`
  .on-demand-screening-button-css {
    .ant-btn:not(:disabled) {
      background-color: #fff;
      border-color: #2B73E0 !important;
      color: #2B73E0 !important;
    }
    .ant-btn-primary:not(:disabled) {
      background-color: #2B73E0 !important;
      border-color: #2B73E0 !important;
      color: #fff !important;
    }
    .ant-btn:not(:disabled):hover {
      background-color: #fff;
      border-color: #5f91dd !important;
      color: #5f91dd !important;
    }
  
    .ant-btn-primary:not(:disabled):hover {
      background-color: #5f91dd !important;
      border-color: #5f91dd !important;
      color: #fff !important;
    }
  }
`;

export const PageHeader = styled.div`
  background: #ffffff;
  font-size: 16px;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  color: #31394d;
  height: 70px;
  font-weight: 700;
  padding: 0 24px;
`;

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 24px 24px;
  background: #ffffff;
  flex: 1 1 0px;
`;

export const StyledTabs = styled(Tabs)`
  .ant-tabs-tab {
    padding: 4px 0px 4px;
    font-size: 16px;
  }

  .ant-tabs-tab-active {
    font-weight: 500;
  }
`;

export const StyledFormItem = styled(Form.Item)`
  & > .ant-form-item-label {
    padding-bottom: 4px;
    height: 24px;
    & > label {
      font-size: 12px;
      line-height: 20px;
      color: #748aa1;
    }
  }
  .ant-form-item-explain-error {
    font-size: 12px;
  }
`;

export const ContentWrapper = styled.div`
  padding: 16px 0px;
`;

export const StyldDivider = styled(Divider)`
  background-color: #d0d7e3;
`;

export const DrawerDesc = styled.div`
  font-size: 12px;
  color: #b8bec5;
  padding-left: 8px;
`;

export const IDLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #659ae0;
  padding-left: 8px;
`;

export const NameLabel = styled.div`
  font-size: 14px;
  color: #556069;
  padding-left: 8px;
`;

export const DrawerDivider = styled(Divider)`
  margin: 16px 0px;
`;

export const StyledAlert = styled(Alert)`
  margin-bottom: 16px;
`;

export const StyledBreadCrumbDiv = styled.div`
  padding: 0 24px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
`;
export const LeftHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const BackButtonContainer = styled.a`
  margin-right: 8px;
  cursor: pointer;
`;

export const StyledAlertDetailsFilters = styled(DetailsFilters)`
  flex-direction: column;

  & > * {
    margin: 0 0 12px 0;
  }

  .DateRangeWithPresets-root .DateRangeWithPresets-duration {
    margin: 0 0 12px 0;
  }
`;
